/**
 * @author: Stefan Binder <stefan.binder89@gmail.com>
 * @class: Home
 * @date:  29.08.2018
 * @time:  08:43
 * @scope:
 */
import { useMediaQuery } from '@hooks/useMediaQuery';
import Paper from '@material-ui/core/Paper';
import { call } from '@packages/functions';
import { get, isNil } from 'lodash';
import React, { useState } from 'react';
import ItemEditOneLineQuantity, { ItemEditOneLineQuantityHeadline } from './ItemEditOneLineQuantity';

interface ItemsEditClientSideProps {
    items: any[];
    onUpdate?: any;
    onDelete?: any;
    orderId?: number;
    showHeadline?: boolean;
    showRowHeadline?: boolean;
    showTierPricing?: boolean;
    disableInputs?: boolean;
}

export default function ItemsEditClientSide(props: ItemsEditClientSideProps) {
    const [items, setItems] = useState(props.items);
    const isMobile = useMediaQuery('max-960');

    const items$: any = [];

    const packageItems = items.filter((item) => item.package).map((item) => ({ ...item, packaged_item: true }));

    const handleUpdateItem = (newItem) => {
        const newItems = [...items].map((item) => {
            if (!isNil(get(newItem, 'package')) && !isNil(get(item, 'package'))) {
                return {
                    ...item,
                    item_specifications: [
                        {
                            quantity: newItem.item_specifications[0].quantity,
                        },
                    ],
                };
            } else if (item.id === newItem.id) {
                return newItem;
            }

            return item;
        });

        setItems(newItems);

        call(props.onUpdate, newItems);
    };

    const handleDeleteItem = (item) => {
        const newItems = items.filter((i) => {
            if (!isNil(get(item, 'package')) && !isNil(get(i, 'package'))) {
                return false;
            } else if (i.id === item.id) {
                return false;
            }
            return true;
        });
        setItems(newItems);
        call(props.onDelete, newItems, item);
    };

    if (packageItems.length > 0) {
        items$.push(
            <ItemEditOneLineQuantity
                key={'package'}
                item={packageItems[0]}
                onUpdate={handleUpdateItem}
                index={0}
                disableInputs={props.disableInputs}
                onDelete={handleDeleteItem}
                showHeadline={props.showRowHeadline}
                showTierPricing={props.showTierPricing}
            />,
        );
    }

    items
        .filter((item) => !item.package)
        .forEach((item, key) => {
            const attrs = {
                key: item.id,
                index: key + 1,
                item: item,
                showHeadline: props.showRowHeadline,
                showTierPricing: props.showTierPricing,
                onUpdate: handleUpdateItem,
                onDelete: handleDeleteItem,
                disableInputs: props.disableInputs,
            };

            items$.push(<ItemEditOneLineQuantity {...attrs} />);
        });

    const renderHeadline = () => {
        const { showHeadline } = props;

        if (showHeadline === true) {
            return <ItemEditOneLineQuantityHeadline count={items.length} />;
        }
    };

    return (
        <Paper elevation={0} style={{ padding: '1px 0' }} square={!isMobile}>
            {renderHeadline()}
            {items$}
        </Paper>
    );
}
